/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Topbar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import InApp from './InApp/index'
import Internal from './Internal/index'
import No from './No/index'
import React from 'react'
import Sms from './Sms/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Topbar({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar"
  
}) {
  let isMedia = useIsMedia()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let threadTypeValueData = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: threadTypeValueData,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Topbar.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z26QrJi': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-Z26QrJi': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-Z26QrJi': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-Z26QrJi': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--fw-5-Z26QrJi': isMedia.mobile ? "wrap" : "nowrap"}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Sms'}>
<Sms
  viewPath={`${viewPath}/Sms`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'InApp'}>
<InApp
  viewPath={`${viewPath}/InApp`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Internal'}>
<Internal
  viewPath={`${viewPath}/Internal`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}